export const categoryLabels: Record<string, string> = {
    nutrition: "Nutrición",
    medications: "Medicamentos",
    vaccines: "Vacunas",
    vitamins: "Vitaminas",
    minerals: "Minerales",
    supplies: "Insumos",
    hygiene_cleaning: "Higiene y desinfección",
    equipment_tools: "Equipamiento y herramientas",
    spare_parts: "Refacciones y repuestos",
    office_supplies: "Material de oficina",
    others: "Otros",
    laboratory: "Laboratorio",
};
